import { render, staticRenderFns } from "./IcoProduct.vue?vue&type=template&id=07ebca06&scoped=true"
import script from "./IcoProduct.vue?vue&type=script&lang=js"
export * from "./IcoProduct.vue?vue&type=script&lang=js"
import style0 from "./IcoProduct.vue?vue&type=style&index=0&id=07ebca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ebca06",
  null
  
)

export default component.exports